import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { MultilingualClient } from './multilingual-client.js';

export function useMultilingualClient(): MultilingualClient {
  const httpClient = useHttpClient({ type: 'api' });
  const client = useMemo(
    () => new MultilingualClient(httpClient),
    [httpClient]
  );

  return usePanoramaMethodLogger(client);
}
